import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HTTPCONSTANTS } from '../http/http-constants';

/* Names · The Perfect Register — client for `process=names-register`.
   Contract: names build pack 02-data-contract §8/§11. The server reads a
   prepared, versioned artifact and joins live availability per page; nothing
   is computed at request time. All totals rendered from this response only. */

export interface NamesRegisterItem {
  registration: string;
  display: string;
  primaryName: string;
  names: string[];
  languages: string[];
  era: 'dateless' | 'suffix' | 'prefix' | 'current';
  state: 'new-issue' | 'resale' | 'previously-sold' | 'held' | 'unknown';
  pricePence: number | null;
  lastSale: { pricePence: number; date: string; saleType: number; verified: boolean } | null;
  detailUrl: string;
}

export interface NamesRegisterResponse {
  metadata: {
    generatedAt: string;
    engineVersion: string;
    datasetVersion: number;
    availability: { joined: boolean; checkedAt: string; snapshotAt: string };
  };
  highlights: {
    travel: { name: string; languages: string[] }[];
    belong: { name: string; language: string }[];
  };
  recordSale: {
    registration: string;
    display: string;
    name: string;
    pricePence: number;
    date: string;
    saleType: number;
  } | null;
  /** Era split of the public Register, e.g. { dateless: 2786, current: 656 }. */
  eraCounts: { [era: string]: number };
  totalUnfiltered: number;
  total: number;
  page: number;
  size: number;
  items: NamesRegisterItem[];
  facets: {
    letters: { [letter: string]: number };
    languages: { [code: string]: number };
    availability: { [state: string]: number };
  };
}

export interface NamesRegisterQuery {
  language?: string;
  availability?: string;
  letter?: string;
  page?: number;
  size?: number;
}

@Injectable({ providedIn: 'root' })
export class NamesRegisterService {
  constructor(private httpClient: HttpClient) {}

  public getRegister(q: NamesRegisterQuery): Observable<NamesRegisterResponse> {
    const params: string[] = ['process=names-register'];
    if (q.language && q.language !== 'all') params.push(`language=${encodeURIComponent(q.language)}`);
    if (q.availability && q.availability !== 'all') params.push(`availability=${encodeURIComponent(q.availability)}`);
    if (q.letter && q.letter !== 'all') params.push(`letter=${encodeURIComponent(q.letter)}`);
    params.push(`page=${q.page || 1}`);
    params.push(`size=${q.size || 60}`);
    return this.httpClient.get<NamesRegisterResponse>(
      `${HTTPCONSTANTS.names_register_protocol}${HTTPCONSTANTS.names_register_base}?${params.join('&')}`
    );
  }
}
